import React from "react";

// mui components
import { Checkbox, TableCell, TableRow } from "@mui/material";

// custom components
import Body3 from "../../typography/body-03";

// custom styles
import styles from "../index.module.scss";

const DocumentTrackerConditionsRow = ({
	row,
	handleRowClick,
	selectedRow,
	showMetaColumns = false,
}) => {
	const rowId =
		row?.id ?? row?.entityId ?? row?.value ?? row?.title ?? row?.label ?? "";
	const isSelected = (name) => selectedRow.indexOf(name) !== -1;
	const isItemSelected = isSelected(rowId);
	const labelId = `document-tracker-condition-checkbox-${rowId}`;

	const conditionName =
		row?.title ?? row?.label ?? row?.name ?? row?.entityName ?? rowId;
	const conditionCategory = row?.category ?? row?.conditionCategory ?? "-";

	return (
		<TableRow
			hover
			tabIndex={-1}
			key={rowId}
			onClick={(event) => handleRowClick(event, rowId)}
			role="checkbox"
			aria-checked={isItemSelected}
			selected={isItemSelected}
			className={styles.conditionRow}
		>
			<TableCell padding="checkbox">
				<Checkbox
					color="primary"
					checked={isItemSelected}
					inputProps={{
						"aria-labelledby": labelId,
					}}
				/>
			</TableCell>
			<TableCell id={labelId}>
				<Body3 text={conditionName} extraClass={styles.greenText} />
			</TableCell>
			<TableCell id={labelId}>
				<Body3 text={row?.conditionType ?? "-"} extraClass={styles.greenText} />
			</TableCell>
			{showMetaColumns ? (
				<>
					<TableCell>
						<Body3 text={conditionCategory} extraClass={styles.greenText} />
					</TableCell>
					<TableCell>
						<Body3 text={row.priorTo} extraClass={styles.greenText} />
					</TableCell>
				</>
			) : null}
		</TableRow>
	);
};

export default DocumentTrackerConditionsRow;
